import React from 'react';
import ReactDOM from 'react-dom';
import { requestJson } from '../../../frontend/scripts/utils/request';
import { Spring, animated } from 'react-spring/renderprops';

import AudioPlayerViewMain from './views/ViewMain';

/*
 * Audio Player
 * ----------------
 *
 * Container for ARN Audio Player.
 * Contains main state and all state manipulation functions
 *
 */

class AudioPlayer extends React.Component {
  constructor(props) {
    super(props);

    this.scheduleId = props.scheduleId;
    this.wrapperElement = props.parentElement;
    this.primary_stream_url = player_data.primary_stream_url;
    this.backup_stream_url = player_data.backup_stream_url;
    this.playerContainerId =
      typeof props.playerContainerId !== 'undefined'
        ? props.playerContainerId
        : false;

    this.spacerId =
      typeof props.spacerId !== 'undefined' ? props.spacerId : false;

    this.logo = typeof props.logo !== 'undefined' ? props.logo : false;
    this.backgroundOne =
      typeof props.backgroundOne !== 'undefined' ? props.backgroundOne : false;
    this.backgroundTwo =
      typeof props.backgroundTwo !== 'undefined' ? props.backgroundTwo : false;
    this.backgroundSplit =
      typeof props.backgroundSplit !== 'undefined'
        ? props.backgroundSplit
        : false;
    this.iheartUrl =
      typeof props.iheartUrl !== 'undefined' ? props.iheartUrl : false;

    this.gfkContentId =
      typeof player_data.gfkContentId !== 'undefined' ? player_data.gfkContentId : false;

    this.gfkAgent = window.gfkS2s.getAgent();
    this.gfkAgentStatus = 'stop';

    // Will be populated with an interval which fires an event to GA every 60 seconds, while audio player is being used
    this.engagementHeartbeat = false;

    // This flag will prevent the player from auto-collapsing if the user has indicated a desire for it to stay expanded
    this.hasTriggeredScrollAway = false;
    this.scrollListener = false;
    this.startScrollPos = false;

    this.currentSongEndTimeStamp = new Date().getTime() + 10000; // load song 10 seconds from page loaded
    this.bufferDuration = 0;

    this.dayMap = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];

    // Whilst we can pass in an expandState on initialisation, there are times when this will need to be overridden
    // in the name of good UX. Two main cases:
    // - If the user's scroll position is sufficiently low enough,
    // - Or if their viewport height is too small.
    let expandState = this.props.expandState === 'expanded';
    if (
      window.screen.height &&
      window.screen.height > 0 &&
      window.screen.height < 600
    ) {
      expandState = false;
    }
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;
    if (scrollPosition > 250 && this.props.adsPlaying === false) {
      expandState = false;
    }
    this.jwPlayer = false;

    this.state = {
      dataSchedule: false, // Full schedule
      dataActiveShow: this.setOnAirFromSchedule(), // JSON object for currently on-air talent.
      dataSong: false, // JSON object for currently playing on-air song.
      dataPodcast: false, // JSON object for active podcast.
      isExpanded: expandState, // Boolean flag which determines whether player should be minimised or maximised.
      audioState: 'stream off',
      isMuted: false,
      paused: false,
    };

    this.wrapperElementClick = this.wrapperElementClick.bind(this);
    this.wrapperElement.addEventListener('click', this.wrapperElementClick);

    this.setUp = this.setUp.bind(this);
    this.setOnAirFromSchedule = this.setOnAirFromSchedule.bind(this);
    this.setExpandState = this.setExpandState.bind(this);
    this.setPodcast = this.setPodcast.bind(this);
    this.initialiseJWPlayer = this.initialiseJWPlayer.bind(this);
    this.playerHealthCheck = this.playerHealthCheck.bind(this);
    this.resetJWPlayer = this.resetJWPlayer.bind(this);

    this.bindAnalyticsEvents = this.bindAnalyticsEvents.bind(this);

    this.createHeartbeat = this.createHeartbeat.bind(this);
    this.fireHeartbeatEvent = this.fireHeartbeatEvent.bind(this);

    this.handlePlayPause = this.handlePlayPause.bind(this);
    this.loadSong = this.loadSong.bind(this);
    this.refreshPlayerData = this.refreshPlayerData.bind(this);

    this.scrollListenerAction = this.scrollListenerAction.bind(this);
    this.scrollListenerCreate = this.scrollListenerCreate.bind(this);
    this.scrollListenerDestroy = this.scrollListenerDestroy.bind(this);

    this.playPodcast = this.playPodcast.bind(this);
    this.pausePodcast = this.pausePodcast.bind(this);
    this.playLiveStream = this.playLiveStream.bind(this);
    this.pauseLiveStream = this.pauseLiveStream.bind(this);

    this.setMute = this.setMute.bind(this);
    this.getMute = this.getMute.bind(this);

    this.setGFKStatus = this.setGFKStatus.bind(this);

    window.setAudioPlayerExpandState = this.setExpandState;
    window.setAudioPlayerPodcast = this.setPodcast;
    window.playLiveStream = this.playLiveStream;
    window.unmuteAudioPlayer = this.setMute;
    window.getAudioPlayerMuteState = this.getMute;

    this.suppress_popup = false;
    this.stream_started = false;

    this.setUp();
  }

  wrapperElementClick(event) {
    const excludedClickTargets = [
      'pa-icon__symbol',
      'pa-icon',
      'po-audio-player__component-active-media__control__button',
      'pa-icon po-audio-player__component-on-air__icon',
      'po-audio-player__collapse-expand-button',
    ];
    let isExcluded = false;
    excludedClickTargets.forEach(targetClass => {
      if (event.target.classList.contains(targetClass)) {
        isExcluded = true;
      }
    });

    if (
      !isExcluded &&
      this.wrapperElement.classList.contains(
        'po-audio-player__main-container--is-minified'
      )
    ) {
      this.setExpandState(`expanded`);
    }
  }

  // Sets up any listeners, intervals, etc which we need in order to run the player
  setUp() {
    const expandState = this.state.expandState;

    if (this.state.isExpanded) {
      this.setExpandState(`expanded`);
    } else {
      this.setExpandState(`minified`);
    }

    this.refreshPlayerData();

    this.initialiseJWPlayer();
    this.playerHealthCheck();

    this.scrollListenerCreate();
    this.bindAnalyticsEvents();
  }

  bindAnalyticsEvents() {
    if (!window.gfkS2s || typeof window.gfkS2s === 'undefined' || typeof window.gfkS2s.getAgent === 'undefined') {
      const playerObj = this;
      setTimeout(function() {
        playerObj.bindAnalyticsEvents();
      }, 2500);
      return;
    }

    const player = this.jwPlayer;

    // Fires when a stream has been started or is playing after having been paused or stopped
    player.on('play', () => {
      this.setGFKStatus('play');
      if (this.state.audioState !== 'stream on') return;
    });

    // Fires when a stream has been paused
    player.on('pause', () => {
      this.setGFKStatus('stop');
    });

    // Fires when a stream has been paused
    player.on('idle', () => {
      this.setGFKStatus('stop');
    });

    // Fires when the current stream is ended
    player.on('complete', () => {
      this.setGFKStatus('stop');
    });

    // Fires when the user starts moving/skipping to a new position in a stream
    player.on('seek', () => {
      this.setGFKStatus('stop');
    });

    player.on('error', () => {
      this.setGFKStatus('stop');
    });

    // Fires when the user is finished moving/skipping to a new position in a stream
    player.on('seeked', () => {
      this.setGFKStatus('play');
    });

    // Fires when the mute button has been changed
    player.on('mute', () => {
      this.setGFKStatus('volume');
    });

    // Fires when the volume has been changed
    player.on('volume', () => {
      this.setGFKStatus('volume');
    });

    // Fires when the fullscreen has been changed
    player.on('fullscreen', () => {
      this.setGFKStatus('fullscreen');
    });
  }

  setGFKStatus(newStatus) {
    if (!this.gfkContentId) return;
    let agent = this.gfkAgent;
    let player = this.jwPlayer;

    if ('stop' === newStatus && 'stop' !== this.gfkAgentStatus) {
      agent.stop();
      this.gfkAgentStatus = 'stop';
    } else if ('play' === newStatus && 'play' !== this.gfkAgentStatus) {
      let currentVolume = player.getMute() === true ? 0 : player.getVolume();
      currentVolume = currentVolume.toString();
      const currentDate = new Date();
      const currentTime = currentDate.toISOString(); // hint: if the livestream is time-shifted, don't use the current time, but the contents time (format: "2018-10-05T14:48:00+04:00")
      const currentShow = this.state.dataActiveShow;
      if (!currentShow) return;
      agent.playStreamLive(
        this.gfkContentId,
        currentTime,
        0,
        this.primary_stream_url,
        {
          screen: 'false',
          volume: currentVolume,
        },
        {
          cliptype: 'live',
          airdate: currentShow.start_time_stamp,
        }
      );
      this.gfkAgentStatus = 'play';
    } else if ('fullscreen' === newStatus) {
      agent.screen('false');
    } else if ('volume' === newStatus) {
      const volume = player.getMute() === true ? 0 : player.getVolume();
      agent.volume(volume.toString());
    }

  }

  refreshPlayerData() {
    let next_load = 60000;

    if (this.currentSongEndTimeStamp) {
      next_load = this.currentSongEndTimeStamp - new Date().getTime();

      if (next_load < 0 || next_load > 300000) {
        next_load = 60000;
      }
    }

    setTimeout(() => {
      this.setState({
        dataActiveShow: this.setOnAirFromSchedule(),
      });

      this.loadSong();

      this.refreshPlayerData();
    }, next_load);
  }

  scrollListenerCreate() {
    if (this.scrollListener) return;
    this.scrollListener = window.addEventListener(
      'scroll',
      this.scrollListenerAction
    );
    this.startScrollPos =
      window.pageYOffset || document.documentElement.scrollTop;
  }

  scrollListenerDestroy() {
    this.scrollListener = false;
    window.removeEventListener('scroll', this.scrollListenerAction);
    this.startScrollPos = false;
  }

  scrollListenerAction() {
    const currentPos = window.pageYOffset || document.documentElement.scrollTop;
    let threshold = 180;
    if (this.hasTriggeredScrollAway) threshold = 500;
    if (
      this.state.isExpanded &&
      (currentPos - this.startScrollPos > threshold ||
        currentPos - this.startScrollPos < -threshold)
    ) {
      this.hasTriggeredScrollAway = true;
      this.setExpandState('minified');
      this.scrollListenerDestroy();
    }
  }

  createHeartbeat() {
    clearInterval(this.engagementHeartbeat);
    this.engagementHeartbeat = setInterval(this.fireHeartbeatEvent, 60 * 1000);
  }

  fireHeartbeatEvent() {
    const audioState = this.state.audioState;
    if (audioState !== 'stream on' && audioState !== 'podcast on') {
      clearInterval(this.engagementHeartbeat);
      return;
    }
    window.ArnAnalytics.customEvent({
      category: 'Engagement',
      action: 'AudioListenPing',
      label: '60s',
    });
  }

  initialiseJWPlayer() {
    this.jwPlayer = jwplayer('audio');

    let targeting = '';

    if (window.AdManager && window.AdManager.globalTargeting) {
      targeting = '&cust_params=user_initiated%3Dtrue%26placement_identifier%3Dwebplayer_preroll';
      for (const [key, value] of Object.entries(
        window.AdManager.globalTargeting
      )) {
        targeting +=
          '%26'+ encodeURIComponent(key) + '%3D' + encodeURIComponent(value);
      }
    }

    const preroll_ad_url = player_data.preroll_tag_url
      ? player_data.preroll_tag_url + targeting
      : '';

    // Sample Tag "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=";

    this.jwPlayer.setup({
      playlist: [
        {
          sources: [
            {
              file: this.primary_stream_url,
              type: 'hls',
            },
            {
              file: this.backup_stream_url,
              type: 'hls',
            },
          ],
        },
      ],
      width: '100%',
      aspectratio: '16:9',
      primary: 'html5',
      hlshtml: 'true',
      flashplayer:
        'https://www.kiis1065.com.au/wp-content/themes/arn/parts/02_organisms/audio_player/jw-player-8.9.3/jwplayer.flash.swf',
      advertising: {
        tag: preroll_ad_url + Math.floor(Math.random() * 1000000 + 1),
        client: 'googima',
        vpaidmode: 'insecure',
        skipoffset: 5,
        skipmessage: 'Skip this ad in XX',
      },
    });

    this.jwPlayer.on('adSkipped', function(event) {
      this.suppress_popup = true;
      document.getElementById('modal-container').classList.remove('four');
      document.getElementById('modal-container').classList.add('out');
      if (window.gtag) {
        gtag('event', 'preroll', {
          event_category: 'tracking',
          event_label: 'Preroll Skipped',
        });
      }
    });

    this.jwPlayer.on('adClick', event => {
      jwplayer('audio').play();

      window.ArnAnalytics.customEvent({
        category: 'Video',
        action: 'Preroll Clicked',
        label: 'Audio Player',
        sendToDmp: true,
      });
    });

    this.jwPlayer.on('adComplete', function(event) {
      this.suppress_popup = true;
      document.getElementById('modal-container').classList.remove('four');

      window.ArnAnalytics.customEvent({
        category: 'Video',
        action: 'Preroll Completed',
        label: 'Audio Player',
        sendToDmp: true,
      });
    });

    this.jwPlayer.on('adTime', function(event) {
      if (!this.suppress_popup) {
        this.suppress_popup = true;
        document.getElementById('modal-container').classList.add('four');
      }
    });

    this.jwPlayer.on('playlistComplete', event => {
      this.playLiveStream();
    });

    const that = this;
    document.addEventListener('DOMContentLoaded', event => {
      document
        .getElementsByClassName('modal-background')[0]
        .addEventListener('click', function(event) {
          if (event.target !== this) {
            return;
          }
          document.getElementById('modal-container').classList.remove('four');
          that.pauseLiveStream();
          this.suppress_popup = false;
        });
    });
  }

  playerHealthCheck() {
    // health check every 20 secs see if we need to reset player
    const that = this;
    setInterval(() => {
      const playerState = jwplayer('audio').getState();

      if (
        that.state.audioState === 'stream on' &&
        playerState !== 'playing' &&
        playerState !== 'paused' &&
        playerState !== 'buffering'
      ) {
        that.resetJWPlayer();
      } else if (playerState === 'buffering') {
        that.bufferDuration += 20;
        // if buffering take too long, there might be some issue, also reload player
        if (that.bufferDuration > 40) {
          that.bufferDuration = 0;
          that.resetJWPlayer();
        }
      }
    }, 20000);
  }

  resetJWPlayer() {


    //this.setGFKStatus('stop');

    jwplayer('audio').stop();
    jwplayer('audio').setup({
      playlist: [
        {
          sources: [
            {
              file: this.primary_stream_url,
              type: 'hls',
            },
            {
              file: this.backup_stream_url,
              type: 'hls',
            },
          ],
        },
      ],
      width: '100%',
      aspectratio: '16:9',
      primary: 'html5',
      hlshtml: 'true',
      flashplayer:
        'https://www.kiis1065.com.au/wp-content/themes/arn/parts/02_organisms/audio_player/jw-player-8.9.3/jwplayer.flash.swf',
    });
    this.bindAnalyticsEvents();

    jwplayer('audio').play();

    console.log('reloading player');
  }

  /* ================================
   * Button Click Handler Functions
   * ================================
   */

  handlePlayPause(event) {
    console.log('HANDLE PLAY PAUSE FIRED');
    console.log(event);

    if (this.state.audioState === 'stream on') {
      console.log('PAUSE Stream CLICK');
      this.pauseLiveStream();
    } else if (this.state.audioState === 'podcast on') {
      console.log('PAUSE Podcast CLICK');
      this.pausePodcast();
    } else if (this.state.audioState === 'podcast off') {
      console.log('PLAY PODCAST CLICK');
      this.playPodcast();
    } else if (this.state.audioState === 'stream off') {
      console.log('PLAY STREAM CLICK');
      this.playLiveStream();
    }

    const isMuted = this.state.isMuted;
    const muteVal = this.getMute();

    if (isMuted !== muteVal) {
      this.setState({
        isMuted: muteVal,
      });
    }
  }

  handleSkipForward = event => {
    if (!this.jwPlayer) return;

    const skipDuration = 30;

    const currentTime = this.jwPlayer.getPosition();
    const maxDuration = this.jwPlayer.getDuration();

    let newTime = currentTime + skipDuration;
    if (newTime > maxDuration) newTime = maxDuration - 1;

    this.jwPlayer.seek(newTime);
    const newPercent = (newTime / this.jwPlayer.getDuration()) * 100;
    audioPlayerTickTimeUpdate(newPercent);
  };

  handleSkipBackward = event => {
    if (!this.jwPlayer) return;
    const skipDuration = 15;
    const currentTime = this.jwPlayer.getPosition();

    let newTime = currentTime - skipDuration;
    if (skipDuration < 0) newTime = 0;

    this.jwPlayer.seek(newTime);
    const newPercent = (newTime / this.jwPlayer.getDuration()) * 100;
    audioPlayerTickTimeUpdate(newPercent);
  };

  handleProgressBarInput = newValue => {
    if (!this.jwPlayer) return;
    const newPercent = newValue;
    const maxDuration = this.jwPlayer.getDuration();
    const newTime = (newPercent / 100) * maxDuration;
    console.log(newTime);
    if (newTime > maxDuration || newTime < 0) return;

    this.jwPlayer.seek(newTime);
    audioPlayerTickTimeUpdate(newPercent);
  };

  /* ================================
   * Exposed Functions
   * ================================
   */

  // Sets the mute value within JW player
  setMute(value) {
    let muteVal = value;
    if (typeof value === 'undefined') {
      muteVal = false;
    }
    if (muteVal) {
      this.jwPlayer.setMute(true);
    } else {
      this.jwPlayer.setMute(false);
      this.jwPlayer.setVolume(100);
    }

    this.setState({
      isMuted: value,
    });
  }

  // Gets the mute value within JW player
  getMute() {
    const muteVal = this.jwPlayer.getMute();
    const volumeVal = this.jwPlayer.getVolume();

    if (muteVal || volumeVal < 1) {
      return true;
    }

    return false;
  }

  setExpandState(newStateProp) {
    if (
      newStateProp !== 'expanded' &&
      newStateProp !== 'minified' &&
      newStateProp !== 'toggle'
    )
      return;
    let newState = newStateProp;

    if (newStateProp === 'toggle') {
      const currentState = this.state.isExpanded;
      if (currentState) {
        newState = 'minified';
      } else {
        newState = 'expanded';
      }
    }

    if (newState === 'expanded') {
      this.setState({
        isExpanded: true,
      });

      this.wrapperElement.classList.add(
        `po-audio-player__main-container--is-expanded`
      );
      this.wrapperElement.classList.remove(
        `po-audio-player__main-container--is-minified`
      );
      this.scrollListenerCreate();

      const currentPos =
        window.pageYOffset || document.documentElement.scrollTop;

      if (this.spacerId && currentPos < 400) {
        const spacerElement = document.querySelector(`#${this.spacerId}`);
        if (spacerElement) {
          spacerElement.classList.add(`po-audio-player__spacer--is-visible`);
        }
      }
      return;
    }

    this.setState({
      isExpanded: false,
    });

    this.wrapperElement.classList.remove(
      `po-audio-player__main-container--is-expanded`
    );
    this.wrapperElement.classList.add(
      `po-audio-player__main-container--is-minified`
    );

    if (this.spacerId) {
      const spacerElement = document.querySelector(`#${this.spacerId}`);
      if (spacerElement) {
        spacerElement.classList.remove(`po-audio-player__spacer--is-visible`);
      }
    }
  }

  setPodcast(title, image_src, audio_src) {
    this.suppress_popup = false;

    this.pauseLiveStream(false);

    this.jwPlayer.setup({
      playlist: [
        {
          file: audio_src,
          type: 'mp3',
        },
      ],
      width: '100%',
      aspectratio: '16:9',
      primary: 'html5',
      hlshtml: 'true',
      flashplayer:
        'https://www.kiis1065.com.au/wp-content/themes/arn/parts/02_organisms/audio_player/jw-player-8.9.3/jwplayer.flash.swf',
    });

    jwplayer('audio').play();

    const muteVal = this.getMute();

    this.setState({
      dataPodcast: {
        podcast_art: image_src,
        podcast_name: title,
        isMuted: muteVal,
      },
      audioState: 'podcast on',
    });

    window.ArnAnalytics.customEvent({
      category: 'Audio Player',
      action: 'Podcast Play',
      label: 'Podcast Play',
      sendToDmp: true,
    });

    this.createHeartbeat();
  }

  playPodcast() {
    this.pauseLiveStream(false);

    jwplayer('audio').play();

    const muteVal = this.getMute();

    this.setState({
      audioState: 'podcast on',
      isMuted: muteVal,
      paused: false,
    });

    window.ArnAnalytics.customEvent({
      category: 'Audio Player',
      action: 'Podcast Play',
      label: 'Podcast Play',
      sendToDmp: true,
    });

    this.createHeartbeat();
  }

  pausePodcast(setState = true) {
    if (setState) {
      this.setState({
        audioState: 'podcast off',
        paused: true,
      });
    }

    jwplayer('audio').pause();

    clearInterval(this.engagementHeartbeat);
  }

  playLiveStream() {
    this.pausePodcast(false);
    this.stream_started = true;

    const currentPlaylistItem = jwplayer('audio').getPlaylistItem();
    if (
      currentPlaylistItem &&
      (currentPlaylistItem.file === this.primary_stream_url ||
        currentPlaylistItem.file === this.backup_stream_url)
    ) {
      jwplayer('audio').play();
    } else {
      jwplayer('audio').load([
        {
          file: this.primary_stream_url,
          type: 'hls',
        },
        {
          file: this.backup_stream_url,
          type: 'hls',
        },
      ]);

      jwplayer('audio').play();
    }

    const muteVal = this.getMute();

    this.setState({
      audioState: 'stream on',
      isMuted: muteVal,
      paused: false,
    });
    this.setExpandState(`expanded`);

    window.ArnAnalytics.customEvent({
      category: 'Audio Player',
      action: 'Live Stream Play',
      label: 'Live Stream Play',
      sendToDmp: true,
    });

    this.createHeartbeat();
  }

  pauseLiveStream(setState = true) {
    if (setState) {
      this.setState({
        audioState: 'stream off',
        paused: true,
      });
    }

    this.stream_started = false;
    jwplayer('audio').pause();
    document.getElementById('modal-container').classList.remove('four');
    document.getElementById('modal-container').classList.add('out');

    clearInterval(this.engagementHeartbeat);
  }

  /* ================================
   * // END Exposed Functions
   * ================================
   */

  // Reads the schedule and compares it against current time to determine which show is on air right now
  setOnAirFromSchedule() {
    let dataActiveShow = false;
    const schedule = JSON.parse(player_data.schedule);

    const date = new Date();
    let day = date.getDay();
    if (day === 0) {
      day = 7;
    }
    const current_timestamp_sequence =
      (day - 1) * 1440 +
      date.getHours() * 60 +
      date.getMinutes() +
      date.getTimezoneOffset() +
      player_data.timeZoneOffset * 60;

    let current_show;
    const default_show = schedule.default;

    if (
      typeof schedule === 'undefined' ||
      typeof schedule.shows === 'undefined'
    ) {
      console.error('no schedule available');
      return false;
    }

    for (let i = 0; schedule.shows && i < schedule.shows.length; i++) {
      if (
        current_timestamp_sequence >= schedule.shows[i].start_time_stamp &&
        current_timestamp_sequence < schedule.shows[i].end_time_stamp
      ) {
        current_show = schedule.shows[i];
        break;
      }
    }

    if (current_show) {
      if (current_show.alt_use_default === true) {
        current_show.alt_image = default_show.alt_image;
        current_show.alt_link = default_show.alt_link;
        current_show.alt_text = default_show.alt_text;
      }
      dataActiveShow = current_show;
    } else {
      dataActiveShow = default_show;
      dataActiveShow.is_default = true;
    }

    return dataActiveShow;
  }

  loadSong() {
    requestJson(
      `https://au.api.iheart.com/api/v3/live-meta/stream/${
        player_data.iHeartId
      }/currentTrackMeta`
    )
      .then(({ data }) => {
        console.log(data);
        data.intro = 'Now Playing';
        this.setState({
          dataSong: data,
        });
        this.currentSongEndTimeStamp = data.endTime;
      })
      .catch(() => {
        const last_played = this.props.dataSong;

        let data = {};

        if (last_played && last_played.title) {
          data = last_played;
          data.intro = 'Just Played';
        }

        this.setState({
          dataSong: data,
        });

        this.currentSongEndTimeStamp = new Date().getTime() + 60000; // if song info not available, reload player after  one minute
      });
  }

  render() {
    const isExpanded = this.state.isExpanded;
    const dataPodcast = this.state.dataPodcast;
    const dataActiveShow = this.state.dataActiveShow;
    const audioState = this.state.audioState;
    const dataSong = this.state.dataSong;
    const isMuted = this.getMute();
    const isPaused = this.state.paused;

    return (
      <div className={`po-audio-player__frontend`}>
        <Spring
          native
          force
          delay={75}
          config={{ tension: 500, friction: 29, precision: 0.875 }}
          from={{ height: isExpanded ? 80 : 380, position: 'relative' }}
          to={{ height: isExpanded ? 380 : 80, position: 'relative' }}
        >
          {props => (
            <animated.div style={props}>
              <AudioPlayerViewMain
                isExpanded={isExpanded}
                dataPodcast={dataPodcast}
                dataActiveShow={dataActiveShow}
                audioState={audioState}
                dataSong={dataSong}
                handlePlayPause={this.handlePlayPause}
                handleSkipForward={this.handleSkipForward}
                handleSkipBackward={this.handleSkipBackward}
                handleProgressBarInput={this.handleProgressBarInput}
                setExpandState={this.setExpandState}
                logo={this.logo}
                iheartUrl={this.iheartUrl}
                backgroundSplit={this.backgroundSplit}
                backgroundOne={this.backgroundOne}
                backgroundTwo={this.backgroundTwo}
                isMuted={isMuted}
                isPaused={isPaused}
              />
            </animated.div>
          )}
        </Spring>
      </div>
    );
  }
}

export default AudioPlayer;

export function initializeAudioPlayer(element, props) {
  console.log(props);
  ReactDOM.render(<AudioPlayer {...props} />, element);
}
